import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import _ from 'lodash';

import * as utils from '../../../utils';
import './workflow_group.scss';

const {
  roles: { isOfficeUser },
  flyout: { addFlyout, FLYOUT_TYPES },
} = utils;

class WorkflowGroup extends Component {
  constructor(props) {
    super(props);

    this.CLASS_NAME = 'brzw-calendar-workflow-group';

    this.onNameClick = this.onNameClick.bind(this);
    this.renderWorkflowChildren = this.renderWorkflowChildren.bind(this);
  }

  onNameClick() {
    const { workflowId, userRole } = this.props;

    if (!isOfficeUser(userRole)) {
      addFlyout(FLYOUT_TYPES.TASK_WORKFLOW_EDIT, { scheduledWorkflowId: workflowId });
    }
  }

  renderWorkflowChildren(isInGroup = true) {
    const { children, expanded } = this.props;

    if (!children) {
      return null;
    }

    const childrenSizeIndexed = _.size(children) - 1;

    return React.Children.map(children, (child, childIndex) => {
      if (React.isValidElement(child)) {
        return React.cloneElement(child, {
          firstInGroup: childIndex === 0,
          lastInGroup: childIndex === childrenSizeIndexed,
          expanded,
          isInGroup,
        });
      }

      return child;
    });
  }

  render() {
    const {
      containerClassName: propsContainerClassName,
      empty,
      expanded,
      leftOffset,
      lengthMultiplier,
      rightOffset,
      workflowName,
      userRole,
    } = this.props;

    const containerClassName = classnames(this.CLASS_NAME, propsContainerClassName, {
      [`${this.CLASS_NAME}--empty`]: empty,
    });

    const buttonClassName = classnames(`${this.CLASS_NAME}__workflow-name btn btn-link`, {
      [`${this.CLASS_NAME}__workflow-name--disable-click-action`]: isOfficeUser(userRole),
    });

    if (!expanded) {
      return this.renderWorkflowChildren(false);
    }

    return (
      <div className={containerClassName}>
        <div
          className={`${this.CLASS_NAME}__wrapper`}
          data-left-offset={leftOffset}
          data-length-multiplier={lengthMultiplier}
          data-right-offset={leftOffset + rightOffset}
        >
          {workflowName && !empty && (
            <div className={`${this.CLASS_NAME}__workflow-name-wrapper`}>
              <button type="button" className={buttonClassName} onClick={this.onNameClick}>
                {workflowName}
              </button>
            </div>
          )}

          {this.renderWorkflowChildren()}
        </div>
      </div>
    );
  }
}

WorkflowGroup.propTypes = {
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  containerClassName: PropTypes.string,
  empty: PropTypes.bool,
  expanded: PropTypes.bool,
  leftOffset: PropTypes.number,
  lengthMultiplier: PropTypes.number,
  rightOffset: PropTypes.number,
  userRole: PropTypes.string,
  workflowId: PropTypes.number,
  workflowName: PropTypes.string,
};

WorkflowGroup.defaultProps = {
  children: null,
  containerClassName: '',
  empty: false,
  expanded: false,
  leftOffset: 0,
  lengthMultiplier: 1,
  rightOffset: 0,
  userRole: '',
  workflowId: null,
  workflowName: '',
};

export default WorkflowGroup;
